import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-two-columns",
    styleUrls: ["./two-columns.component.scss"],
    templateUrl: "./two-columns.component.html"
})
export class FUITwoColumnsComponent {
    @Input() minColWidth: number = 300;
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};
}
